var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"className":"w-6 h-6","fill":"currentColor","stroke":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"{2}","d":"M4 6h16M4 12h8m-8 6h16"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }